;(() => {

	if (typeof __webpack_require__.e !== 'undefined') {
	  var _origEnsure = __webpack_require__.e;
	  var _countMap = {};
	  var _STATIC_POOL = ["https://web-in-test2.almmrc.com"];

	  __webpack_require__.e = function(chunkId) {
	    // SW 已激活时退出控制权，由 SW 全权处理 chunk 加载重试，避免双重重试
	    if (typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.controller) {
	      return _origEnsure(chunkId);
	    }

	    return _origEnsure(chunkId).catch(function(error) {
	      // 每次重试时动态读取 DoH 域名，追加到静态池末尾
	      var _DOMAIN_POOL = (function(base) {
	        try {
	          var doh = window.__CDN_DOH_DOMAINS__;
	          if (!Array.isArray(doh) || !doh.length) return base;
	          var result = base.slice();
	          for (var i = 0; i < doh.length; i++) {
	            if (result.indexOf(doh[i]) === -1) result.push(doh[i]);
	          }
	          return result;
	        } catch(e) { return base; }
	      })(_STATIC_POOL);
	      var maxRetries = _DOMAIN_POOL.length;
	      var retries = _countMap.hasOwnProperty(chunkId) ? _countMap[chunkId] : maxRetries;

	      if (retries < 1) {
	        var realSrc = __webpack_require__.u(chunkId);
	        error.message = 'Loading chunk ' + chunkId + ' failed after ' + maxRetries + ' retries.\n(' + realSrc + ')';
	        error.request = realSrc;
	        throw error;
	      }

	      return new Promise(function(resolve) {
	        var retryAttempt = maxRetries - retries;
	        _countMap[chunkId] = retries - 1;

	        if (retryAttempt < _DOMAIN_POOL.length) {
	          try {
	            var pathSuffix;
	            try { pathSuffix = new URL(__webpack_require__.p).pathname; }
	            catch(e) { pathSuffix = __webpack_require__.p; }
	            __webpack_require__.p = _DOMAIN_POOL[retryAttempt] + pathSuffix;
	          } catch(e) {}
	        }

	        resolve(__webpack_require__.e(chunkId));
	      });
	    });
	  };
	}
})();